export class OrderAccess {
  constructor(access = {}) {
    this.id = access.id ?? '';
    this.productId = access.productId ?? '';
    this.productName = access.productName ?? '';
    this.itemId = access.itemId ?? '';
    this.horizontal = access.horizontal ?? '';
    this.status = access.status ?? '';
    this.startsAt = access.startsAt ?? null;
    this.expiresAt = access.expiresAt ?? null;
    this.accumulatedExpiresAt = access.accumulatedExpiresAt ?? null;
  }

  // Vigência efetiva: a acumulada (mais estendida, por outros pedidos) tem prioridade
  // sobre a vigência isolada do pedido. Ver FUK2-13260.
  get effectiveExpiresAt() {
    return this.accumulatedExpiresAt ?? this.expiresAt;
  }

  static fromJson(json) {
    return new OrderAccess({
      id: json.id ?? '',
      productId: json.product_id ?? '',
      productName: json.product_name ?? '',
      itemId: json.item_id ?? '',
      horizontal: json.horizontal ?? '',
      status: json.status ?? '',
      startsAt: json.starts_at ?? null,
      expiresAt: json.expires_at ?? null,
      accumulatedExpiresAt: json.accumulated_expires_at ?? null,
    });
  }
}
